import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LocalizedText from '@LocalizedText';
import './Spinner.scss';

const Spinner = ({ show, message }) => {
  const [loadingMessage, setLoadingMessage] = useState();

  useEffect(() => {
    setLoadingMessage(message);
  }, [message]);

  useEffect(() => {
    if (show) {
      const handleKeyDown = e => {
        e.preventDefault();
        e.stopPropagation();
      };

      document.addEventListener('keydown', handleKeyDown, true);

      return () => {
        document.removeEventListener('keydown', handleKeyDown, true);
      };
    }
  }, [show]);

  return (
    show && (
      <div id="qau-spinner" data-testid="qau-spinner">
        <svg width="180" height="180" viewBox="0 0 95 95" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
          <g transform="translate(30 1)" strokeWidth="2" fill="none">
            <g>
              <circle strokeOpacity=".5" cx="18" cy="18" r="18" />
              <path d="M18,0 a18,18 0 1,1 0,36 a18,18 0 1,1 0,-36" strokeDasharray="113 113" strokeDashoffset="84.75" />
              <animateTransform
                attributeType="xml"
                attributeName="transform"
                type="rotate"
                from="0 18 18"
                to="360 18 18"
                begin="0"
                dur="1s"
                repeatCount="indefinite"
              />
            </g>
          </g>
          <text
            x="50"
            y="53.5"
            fill="#fff"
            fontFamily="Roboto, sans-serif"
            fontSize="10"
            stroke="none"
            textAnchor="middle"
            fontWeight="normal"
          >
            {loadingMessage && <LocalizedText id={loadingMessage} />}
          </text>
        </svg>
      </div>
    )
  );
};

const mapStateToProps = ({ spinner }) => ({
  message: spinner.message,
  show: spinner.show,
});

Spinner.propTypes = {
  show: PropTypes.bool,
  message: PropTypes.string,
};

export default connect(mapStateToProps)(Spinner);
